import request from '@/router/axios'
import env from '@/config/env'

/**
 * 分页列表
 */
export const list = (data) => {
  return request({
    url: env.ferryUrl + '/priceMethod/page',
    method: 'post',
    data: data
  })
}
/**
 * 保存价格方案
 * @param data
 */
export const save = (data) => {
  return request({
    url: env.ferryUrl + '/priceMethod/save',
    method: 'post',
    data: data
  })
}

/**
 * 编辑
 * @param data
 */
export const edit = (data) => {
  return request({
    url: env.ferryUrl + '/priceMethod/update',
    method: 'post',
    data: data
  })
}


/**
 * 通过班次id修改价格方案
 * @param data
 */
 export const savePriceMethod = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/savePriceMethod',
    method: 'post',
    data: data
  })
}

/**
 * 通过价格方案id获取详情
 * @param id
 */
 export const getPriceDetail = (priceMethodId) => {
  return request({
    url: env.ferryUrl + `/flightManage/getPriceDetail/${priceMethodId}`,
    method: 'get',
  })
}

/**
 * 通过班次id获取价格方案详情
 * @param id
 */
 export const selectPriceDetail = (priceMethodId) => {
  return request({
    url: env.ferryUrl + `/flightManage/selectPriceDetail/${priceMethodId}`,
    method: 'get',
  })
}

/**
 * 详情
 * @param id
 */
 export const getInfo = (id) => {
  return request({
    url: env.ferryUrl + '/priceMethod/detail',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 详情
 * @param id
 */
export const details = (id) => {
  return request({
    url: env.ferryUrl + '/priceMethod/getEditBackShow',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 删除
 * @param id
 */
export const deleted = (id) => {
  return request({
    url: env.ferryUrl + '/priceMethod/delete',
    method: 'get',
    params: {
      id: id
    }
  })
}
/**
 * 获取线路下拉数据
 */
export const getLineSelect = () => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineList',
    method: 'get'
  })
}

/**
 * 获取站点规则下拉数据
 */
export const getStationRuleSelect = (id) => {
  return request({
    url: env.ferryUrl + `/stationRuleAdmin/listByLineId?lineId=${id}`,
    method: 'get'
  })
}

/**
 * 获取站点规则详情线路
 * @param id
 */
export const getStationRuleList = (ruleId) => {
  return request({
    url: env.ferryUrl + `/stationRuleAdmin/queryStationRuleById/${ruleId}`,
    method: 'PUT'
  })
}
/**
 * 获取站点规则下拉数据
 */
export const getSeatSelect = () => {
  return request({
    url: env.ferryUrl + `/flightManage/findSeatsList`,
    method: 'post'
  })
}

/**
 * 获取站点规则下拉数据
 */
export const getSeatNumSelect = (seat) => {
  return request({
    url: env.ferryUrl + `/flightManage/findBySeat/${seat}`,
    method: 'post'
  })
}

/**
 * 生成区间价格
 * @param params
 */
export const createPrice = (params) => {
  return request({
    url: env.ferryUrl + '/priceMethod/section2',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 * 获取线路地图信息
 * @param lineId
 */
export const lineMap = (lineId) => {
  return request({
    url: env.ferryUrl + `/stationRuleAdmin/findLineByLineId/${lineId}`,
    method: 'get'
  })
}
